import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams, useHistory } from 'react-router-dom';
import { Input, Button } from 'antd';
import ls from 'local-storage';

import { getPackage, isPackageExpired } from 'services';
import { NOTIFICATION } from '../../constants';
import NwHomeLayout from 'components/Layout/NwHomeLayout';

const Wrapper = styled.div`

  .code-wrapper {
    max-width: 460px;
    margin-left: auto;
    margin-right: auto;
    background: white;
    padding: 16px;
    margin-top: 20vh;

    .code-input {
      margin-top: 8px !important;
      font-size: 20px;
    }
    .code-button {
      margin-top: 16px;
    }
    .error-msg {
      color: red;
      display: flex;
      justify-content: flex-end;
    }
  }
`;

const Home = () => {
    const history = useHistory();
    const { code } = useParams();
    const [inputCode, setInputCode] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState('');
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (code) {
            getPackageByCode(code);
        }
    }, []);

    const getPackageByCode = async code => {
        setIsFetching(true);
        try {
            const response = await getPackage(code);
            if (response) {
                if (isPackageExpired(response)) {
                    setShowErrorMsg(NOTIFICATION.EXPIRED_CODE);
                    setIsFetching(false);
                } else {
                    ls.remove('nw_config_package_view');
                    setIsFetching(false);
                    history.push({
                        pathname: `ebook/${code}`,
                        state: response
                    });
                }
            } else {
                throw new Error('Invalid Code');
            }
        } catch (error) {
            switch (error.response.status) {
                case 404:
                    setShowErrorMsg(NOTIFICATION.INVALID_CODE);
                    break;
                case 400:
                    if (error.response.data === "Package expired") {
                        setShowErrorMsg(NOTIFICATION.EXPIRED_CODE);
                    } else {
                        setShowErrorMsg(NOTIFICATION.INVALID_CODE);
                    }
                    break;
                default:
                    setShowErrorMsg(NOTIFICATION.UNAVAILABLE);
                    break;
            }
            setIsFetching(false);
        }
    };

    const handleChangeCode = event => {
        setInputCode(event.target.value);
        if (showErrorMsg) {
            setShowErrorMsg('');
        };
    };

    const handleSearchPackage = async () => {
        if (inputCode) {
            await getPackageByCode(inputCode);
        } else {
            setShowErrorMsg(NOTIFICATION.EMPTY_CODE);
        }
    };

    return (
        <NwHomeLayout>
            <Wrapper>
                <div className="code-wrapper">
                    <p>Package Code</p>
                    <Input className="code-input" placeholder='xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' value={inputCode} onChange={handleChangeCode} required />
                    {showErrorMsg &&
                        <span className="error-msg">{showErrorMsg}</span>
                    }
                    <Button className="code-button" size="large" type="primary" loading={isFetching} onClick={handleSearchPackage}>submit</Button>
                </div>
            </Wrapper>
        </NwHomeLayout>
    )
};

export default Home;
